/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SiteDocument
 */
export interface SiteDocument {
  /**
   *
   * @type {string}
   * @memberof SiteDocument
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof SiteDocument
   */
  displayName: string
}

export function SiteDocumentFromJSON(json: any): SiteDocument {
  return SiteDocumentFromJSONTyped(json, false)
}

export function SiteDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteDocument {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    displayName: json['display_name']
  }
}

export function SiteDocumentToJSON(value?: SiteDocument | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    display_name: value.displayName
  }
}
